document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".face-swatches-tab-button");
  const tabContents = document.querySelectorAll(".face-swatches-tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedMeta = button.getAttribute("data-meta");

      tabButtons.forEach((b) => b.classList.remove("active"));
      button.classList.add("active");

      tabContents.forEach((content) => {
        if (content.getAttribute("data-meta") === selectedMeta) {
          content.classList.remove("hidden");
        } else {
          content.classList.add("hidden");
        }
      });
    });
  });
});
